import { Card, Muted, Spinner, Tag, fmtDateTime, useAsync } from '../../ui.jsx';
import { adminApi } from '../../api/endpoints.js';

const actionLabels = {
  'dates.update': 'Dates changed',
  'programme.create': 'Programme added',
  'programme.update': 'Programme edited'
};

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return 'not set';
  if (typeof value === 'boolean') return value ? 'yes' : 'no';
  return String(value);
};

export default function AdminActivity() {
  const { data, loading, error } = useAsync(() => adminApi.activity(), []);

  if (loading) return <Spinner label="Loading change history" />;
  if (error) return <div className="note">We could not load the change history. Please try again.</div>;

  const entries = data?.activity || [];

  return (
    <>
      <h2>Change history</h2>
      <Muted>
        Every change to your dates and programmes, with who made it. Application review, offers and
        rejections are kept on each application instead.
      </Muted>

      {entries.length === 0 ? (
        <Card>
          <Muted>Nothing has been changed from this dashboard yet.</Muted>
        </Card>
      ) : (
        entries.map((entry) => (
          <Card key={entry.id}>
            <div className="row sp">
              <div>
                <b>{actionLabels[entry.action] || entry.action}</b>
                <div className="mu">
                  {entry.target} · {entry.by || 'Unknown'} · {fmtDateTime(entry.at)}
                </div>
              </div>
              <Tag>settings</Tag>
            </div>
            <div style={{ marginTop: 10 }}>
              {Object.entries(entry.changes || {}).map(([key, change]) => (
                <div className="prog" key={key}>
                  <div style={{ flex: 1 }}>
                    <b>{key}</b>
                    <div className="mu">
                      {formatValue(change.from)} <span aria-hidden="true">to</span> {formatValue(change.to)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        ))
      )}
    </>
  );
}
